export default {
    'create-unit-size': 'إنشاء وحدة قياس',
    'edit-unit-size': 'تعديل وحدة قياس',

    'unit-size-name': 'اسم وحدة القياس',
    'notes': 'ملاحظات',

    save: 'حفظ',
    cancel: 'إلغاء',
    
    'delete-the-unit-size': 'حذف وحدة القياس',
    'are-you-sure-you-want-to-delete-the-unit-size': 'هل أنت متأكد من حذف وحدة القياس؟',

    headers: {
        'unit-size': 'وحدة القياس',
        'notes': 'الملاحظات',
        'actions': 'الأحداث',
    }
}